// Shared form-field definitions for Advance Search Material.
// Imported by both the page (searchMaterial.vue) and the reusable form
// component (MaterialSearchForm.vue) so the URL-sync key list never drifts.

export const initialFormData = {
  material: "",
  // Basic Data
  item_name: "",
  item_type: "",
  material_type: "",
  material_group: "",
  uom: "",
  valuation_class: "",
  group_class: "",
  old_material_number: "",
  client:"",
  // Plant
  plant: "",
  location: "",
  mind_id_number: "",
  mrp_group: "",
  mrp_type: "",
  material_freight_group: "",
  // Manufacture & Equipment
  manufacture_code: "",
  manufacture_ref: "",
  equipment: "",
  // Other
  mcr_number: "",
  created_at: "",
};

export const queryFields = Object.keys(initialFormData);
